import PortifolioList from "../components/portifolio/PortifolioList";

const PortifolioTwo = () => {
  return (
    <div className="pt-20 max-w-7xl mx-auto px-4">
      <PortifolioList flex />
    </div>
  );
};

export default PortifolioTwo;
